const constants = {
  expeditionSearch: 'expedicion',
  officeSearch: 'despacho',
  itemsPerPage: 10
}

export default constants;